import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { SearchQuery } from '../models/search-query.model';
import { FlyingClubFinderFilter, FLYING_CLUB_MEMBERSHIP_OPTIONS, FLYING_CLUB_BENEFITS_OPTIONS, FLYING_CLUB_FLYING_OPTIONS } from '../../shared/models/flying-club-finder-filter.model';
import { FlyingClubFinderFiltersService } from '../../shared/services/flying-club-finder-filters.service';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
/**
 * Filter UI for the Flying Club Finder, mirroring {@link EventFilterListComponent}. Renders a keyword
 * field, club-type checkboxes, and the Membership / Benefits / Types-of-Flying facet groups. Reads and
 * writes the shared {@link FlyingClubFinderFiltersService} state and emits `filtersChange`.
 */
var FlyingClubFinderFilterListComponent = /** @class */ (function () {
    function FlyingClubFinderFilterListComponent(_flyingClubFinderFiltersService, _analyticsService) {
        this._flyingClubFinderFiltersService = _flyingClubFinderFiltersService;
        this._analyticsService = _analyticsService;
        this.filtersChange = new EventEmitter();
        this.membershipOptions = FLYING_CLUB_MEMBERSHIP_OPTIONS;
        this.benefitsOptions = FLYING_CLUB_BENEFITS_OPTIONS;
        this.flyingOptions = FLYING_CLUB_FLYING_OPTIONS;
        this.flyingClubFinderFilter = new FlyingClubFinderFilter();
    }
    Object.defineProperty(FlyingClubFinderFilterListComponent.prototype, "nameTooShort", {
        /**
         * True when a club name has been entered but is too short to count toward a search. Mirrors the
         * `clubKeyword.length >= 3` gate in {@link SearchQuery.validate}, so the hint shows exactly while
         * the entered name would be ignored.
         */
        get: function () {
            var trimmed = this.flyingClubFinderFilter.name ? this.flyingClubFinderFilter.name.trim() : '';
            return trimmed.length > 0 && trimmed.length < 3;
        },
        enumerable: true,
        configurable: true
    });
    FlyingClubFinderFilterListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscription = this._flyingClubFinderFiltersService.flyingClubFinderFilter.subscribe(function (f) {
            _this.flyingClubFinderFilter = f;
        });
        this._analyticsService.pageView('airport_landingpage_flyingclub', 'Flying Club Finder Landing Page filters');
    };
    FlyingClubFinderFilterListComponent.prototype.ngOnDestroy = function () {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    };
    FlyingClubFinderFilterListComponent.prototype.isFacetSelected = function (group, value) {
        return this.flyingClubFinderFilter[group].indexOf(value) !== -1;
    };
    FlyingClubFinderFilterListComponent.prototype.onToggleFacet = function (group, value, checked) {
        var selected = this.flyingClubFinderFilter[group];
        var i = selected.indexOf(value);
        if (checked && i === -1) {
            selected.push(value);
        }
        else if (!checked && i !== -1) {
            selected.splice(i, 1);
        }
        this._emit();
    };
    FlyingClubFinderFilterListComponent.prototype.onSelectAll = function (group, options) {
        this.flyingClubFinderFilter[group] = options.map(function (o) { return o.value; });
        this._emit();
    };
    FlyingClubFinderFilterListComponent.prototype.onClearAll = function (group) {
        this.flyingClubFinderFilter[group] = [];
        this._emit();
    };
    FlyingClubFinderFilterListComponent.prototype.onToggleClubType = function () {
        this._emit();
    };
    FlyingClubFinderFilterListComponent.prototype.onNameChange = function () {
        this._emit();
    };
    FlyingClubFinderFilterListComponent.prototype._emit = function () {
        // Keep the query's filter in sync as the user edits, so a club name entered here counts toward search
        // validation (see SearchQuery.validate) even before the query is serialized/submitted.
        if (this.query) {
            this.query.flyingClubFinderFilter = this.flyingClubFinderFilter;
        }
        this._flyingClubFinderFiltersService.updateFlyingClubFinderFilters(this.flyingClubFinderFilter);
        this.filtersChange.emit();
    };
    return FlyingClubFinderFilterListComponent;
}());
export { FlyingClubFinderFilterListComponent };
